/** Volunteer may claim deliveries only after admin photo-ID approval. */
export function isVolunteerIdApproved(user?: {
  userType?: string
  volunteerIdVerification?: { status?: string } | null
} | null): boolean {
  if (!user) return false
  if (user.userType === 'ADMIN') return true
  return user.volunteerIdVerification?.status === 'APPROVED'
}

export function volunteerIdRestrictionMessage(user?: {
  volunteerIdVerification?: { status?: string; rejectionReason?: string | null } | null
} | null): string {
  const status = user?.volunteerIdVerification?.status
  if (status === 'REJECTED') {
    const reason = user?.volunteerIdVerification?.rejectionReason?.trim()
    return reason
      ? `Your photo ID was rejected. Reason: ${reason}`
      : 'Your photo ID was rejected. Please re-upload a clear photo of your driver’s license or permit.'
  }
  if (status === 'PENDING') {
    return 'Your photo ID is pending admin approval. You can browse deliveries, but you cannot claim them until approved.'
  }
  return 'Please upload your photo ID. Claiming is disabled until an admin approves it.'
}
